module.exports = __webpack_public_path__ + "img/Tesoura de poda.cdd4cc79.webp";